export default "__VITE_ASSET__39d9849a__"